import { Avatar, Box, FormControl, Grid, ListItemIcon, ListItemText, MenuItem, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../assets/styles/plans.css";
import countriesData from "../data/countriesList.json";
import { nextViewSignupEmployeeState, previousViewSignupEmployeeState, updateSignupEmployeeState } from "../redux/features/signupEmployeeStateSlice";
import IconButtonFileUpload from "./ImageUploader";
import { MapPredictive } from "./mapPredictive";
import { SignUpNextButton } from "./signupNextButton";

const formatPhoneNumber = (number) => {
  let formattedNumber = '';
  if (number.length >= 7) {
    return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
  } else if (number.length >= 4) {
    return `(${number.slice(0, 3)}) ${number.slice(3)}`;
  } else if (number.length >= 1) {
    return `(${number}`;
  }
  return "";
};

export const ConnectEmployeeOne = ({ updateComponentState, componentState }) => {
  const currPage = "/signupEmployee";
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [companyCountry, setCompanyCountry] = useState("");
  const [companyState, setCompanyState] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyCity, setCompanyCity] = useState("");
  const [companyZipCode, setCompanyZipCode] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const signupEmployeeState = useSelector((state) => state.signupEmployeeState);
  const { currentView } = signupEmployeeState;
  const [isFormValid, setIsFormValid] = useState(false);
  const [formatNumber, setFormatNumber] = useState(formatPhoneNumber(signupEmployeeState.phone));

  const handleLocationSelect = (city, state, zipCode, country, address) => {
    setCompanyCity(city);
    setCompanyState(state);
    setCompanyZipCode(zipCode);
    setCompanyCountry(country); // Asegúrate de actualizar el estado del país
    setCompanyAddress(address);
    console.log(address, state, city, zipCode, country);
    dispatch(updateSignupEmployeeState({ address, state, city, zipCode, country }));
  };

  const [isVisible, setIsVisible] = useState(false);

  const countries = countriesData;
  const [isCodesOpen, setIsCodesOpen] = useState(false);

  useEffect(() => {
    const phoneValid = signupEmployeeState.phone?.length === 10;
    const addressValid = signupEmployeeState.address?.length > 0;
    const cityValid = signupEmployeeState.city?.length > 0;
    const stateValid = signupEmployeeState.state?.length > 0;
    const countryValid = signupEmployeeState.country?.length > 0;
    const zipValid = signupEmployeeState.zipCode?.length === 5;

    setIsFormValid(phoneValid && addressValid && cityValid && stateValid && countryValid && zipValid);
  }, [signupEmployeeState.phone, signupEmployeeState.address, signupEmployeeState.city, signupEmployeeState.state, signupEmployeeState.country, signupEmployeeState.zipCode]);

  useEffect(() => {
    // dispatch(updateForm({ state: "businessInformation" }));
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 200);
    return () => clearTimeout(timeout);
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "age") {
      const validInput = value?.replace(/[^0-9]/g, "");
      if (validInput === signupEmployeeState?.[name]) return;
      dispatch(updateSignupEmployeeState({ [name]: validInput }));
      return;
    }

    if (name === "phone") {
      const rawNumber = value?.replace(/[^0-9]/g, "");
      setFormatNumber(formatPhoneNumber(rawNumber));
      if (rawNumber === signupEmployeeState?.[name]) return;
      dispatch(updateSignupEmployeeState({ [name]: rawNumber }));
      return;
    }

    if (["city", "state", "country"].includes(name)) {
      const validInput = value?.replace(/[^a-zA-Z\s.-]/g, "");
      if (validInput === signupEmployeeState?.[name]) return;
      dispatch(updateSignupEmployeeState({ [name]: validInput }));
      return;
    }

    dispatch(updateSignupEmployeeState({ [name]: value }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    setOpen(true);
    const formData = new FormData(event.currentTarget);

    const userData = {
      phone: formData.get("phone").replace(/[^0-9]/g, ""),
      age: formData.get("age"),
      countryCode: formData.get("countryCode"),
      // address: formData.get("address"),
    };
    dispatch(updateSignupEmployeeState(userData));
    dispatch(nextViewSignupEmployeeState(userData));
    setIsLoading(false);
    setOpen(false);
    setIsFormValid(true);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        style={{
          borderRadius: "10px",
          backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
          display: "flex",
          flexDirection: "column",
          padding: "20px",
          alignItems: "center",
          transition: "opacity 1s ease-in-out",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
        }}
        sx={{
          marginTop: { xs: 0, md: 1 },
          width: { xs: "100%", md: 600 },
          height: { xs: "640px", md: "650px" },
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontFamily: "Tahoma, sans-serif",
                fontWeight: "bold",
                color: "White",
                background: "var(--fx-surface-sidebar, #233044)",
                padding: "10px",
                width: "100%", // Full width
                marginBottom: "10px",
                borderRadius: "10px",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              Let's create your profile
            </Typography>
            <Avatar sx={{ width: "90px", height: "90px" }} src={componentState.imageUrl} />
            <IconButtonFileUpload updateComponentState={updateComponentState} />
            {/* Here is where we need to put form */}
            <TextField
              margin="normal"
              // required
              optional
              id="age"
              type="text"
              label="Age (Optional)"
              name="age"
              size="small"
              variant="outlined"
              onChange={handleInputChange}
              value={signupEmployeeState.age}
              autoFocus
              inputProps={{
                maxLength: 3,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
              sx={{
                fontSize: "12px",
                width: "100%",
                marginBottom: "3%",
              }}
            />

            <Box sx={{ display: "flex", width: "100%", mt: 0.2 }}>
              <FormControl variant="outlined" sx={{ width: "auto", mr: 1 }}>
                <Select
                  value={signupEmployeeState.countryCode}
                  onChange={handleInputChange}
                  onOpen={() => setIsCodesOpen(true)}
                  onClose={() => setIsCodesOpen(false)}
                  name="countryCode"
                  variant="outlined"
                  fullWidth
                  size="small"
                  renderValue={(selected) => {
                    const selectedCountry = countries.find((data) => `${data.alpha3}-${data.numberPrefix}` === selected);
                    return selectedCountry ? (
                      <Box sx={{ display: "flex", alignItems: "center", pr: { xs: selectedCountry.numberPrefix.length > 2 ? 8.5 : 5, md: 6 } }}>
                        <img src={selectedCountry.file_url} alt={selectedCountry.name} width="20" style={{ marginRight: 5 }} />+{selectedCountry.numberPrefix}
                      </Box>
                    ) : (
                      ""
                    );
                  }}
                >
                  {countries.map((data) => (
                    <MenuItem key={data.alpha3} value={`${data.alpha3}-${data.numberPrefix}`}>
                      <ListItemIcon>
                        <img src={data.file_url} alt={data.name} width="22" />
                      </ListItemIcon>
                      {isCodesOpen ? <ListItemText primary={`${data.name} +${data.numberPrefix}`} /> : <ListItemText primary={`+${data.numberPrefix}`} />}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                required
                id="phone"
                type="phone"
                label="Phone Number"
                name="phone"
                size="small"
                variant="outlined"
                onChange={handleInputChange}
                inputProps={{
                  maxLength: 14,
                  inputMode: "numeric",
                }}
                error={signupEmployeeState?.phone && signupEmployeeState.phone?.length !== 10}
                helperText={signupEmployeeState?.phone && signupEmployeeState?.phone?.length !== 10 ? "Phone number must be 10 digits" : ""}
                value={formatNumber}
                sx={{
                  fontSize: "12px",
                  width: "100%",
                }}
              />
            </Box>

            <Grid item xs={12} style={{ width: "100%", marginBottom: "2%", marginTop: 10 }}>
              <MapPredictive onLocationSelect={handleLocationSelect} updateComponentState={updateComponentState} componentState={componentState} />
            </Grid>

            <Grid item xs={12} style={{ width: "100%", marginBottom: "2%", marginTop: 5 }}>
              <TextField
                required
                fullWidth
                label="City"
                name="city"
                size="small"
                variant="outlined"
                onChange={handleInputChange}
                value={signupEmployeeState.city}
                InputLabelProps={{
                  shrink: !!signupEmployeeState.city, // La etiqueta se encogerá si el campo 'city' tiene un valor
                }}
              />
            </Grid>

            <Grid item xs={12} style={{ width: "100%", marginBottom: "2%", marginTop: 5 }}>
              <TextField
                required
                fullWidth
                label="State"
                name="state"
                size="small"
                variant="outlined"
                onChange={handleInputChange}
                value={signupEmployeeState.state}
                InputLabelProps={{
                  shrink: !!signupEmployeeState.state, // La etiqueta se encogerá si el campo 'state' tiene un valor
                }}
              />
            </Grid>

            <Grid item xs={12} style={{ width: "100%", marginBottom: "2%", marginTop: 5 }}>
              <TextField
                required
                fullWidth
                label="Zip Code"
                name="zipCode"
                size="small"
                variant="outlined"
                onChange={handleInputChange}
                inputProps={{
                  required: true,
                  maxLength: 5,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                error={signupEmployeeState?.zipCode && signupEmployeeState?.zipCode?.length !== 5}
                helperText={signupEmployeeState?.zipCode && signupEmployeeState?.zipCode?.length !== 5 ? "ZipCode number must be 5 digits" : ""}
                value={signupEmployeeState.zipCode}
                InputLabelProps={{
                  shrink: !!signupEmployeeState.zipCode, // La etiqueta se encogerá si el campo 'state' tiene un valor
                }}
              />
            </Grid>

            <Grid item xs={12} style={{ width: "100%", marginTop: 5 }}>
              <TextField
                required
                fullWidth
                label="Country"
                name="country"
                size="small"
                variant="outlined"
                onChange={handleInputChange}
                value={signupEmployeeState.country}
                InputLabelProps={{
                  shrink: !!signupEmployeeState.country, // La etiqueta se encogerá si el campo 'state' tiene un valor
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid container margin="auto" sx={{ height: "100%" }}>
          <Grid
            item
            xs
            sx={{
              mr: 1,
              height: "20px",
              display: "flex",
              // marginLeft: "10px",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <SignUpNextButton
              sx={{
                marginTop: "20px",
              }}
              type="submit"
              disabled={!isFormValid}
              nextViewEntityState={nextViewSignupEmployeeState}
              previousViewEntityState={previousViewSignupEmployeeState}
            ></SignUpNextButton>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};
